export const addNotification = (setData, entry) =>
    setData((prev) => {
        const list = prev.notifications ?? []
        if (list.some((n) => n.message === entry.message)) return prev
        return {...prev, notifications: [entry, ...list]}
    })

export const removeNotification = (setData, id) =>
    setData((prev) => ({
        ...prev,
        notifications: (prev.notifications ?? []).filter((n) => n.id !== id),
    }))

export const clearNotifications = (setData) =>
    setData((prev) => ({
        ...prev,
        notifications: [],
    }))
